import MainComponent from "./Components/MainComponent";
import LoginState from "./context/Login/LoginState"
import React from 'react'
import PrivateRoute from "./routes/PrivateRoute";
import { BrowserRouter as Router, Route, Switch} from "react-router-dom";
import './styles/fontawesome-free-5.15.4-web/css/all.css'
// import AuthScreen from "./Components/RegisterScreen";
// import LoginScreen from "./Components/LoginScreen";
// import PrivacidadComponent from "./Components/PrivacidadComponent";
import BuroComponente from "./Components/BuroComponente";

function App() {

  return (
    <>
    <LoginState>
      <Router>
        <Switch>
          <Route path="/credito" exact component={MainComponent}/>
          <PrivateRoute path="/credito/buro" component={BuroComponente}/>
        </Switch>
      </Router>
    </LoginState>
    </>
  );
}

export default App;
